"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const select_styles_1 = require("./select.styles");
const Select = (_a) => {
    var { options, children, lastOptionRef, placeholder, renderValue, value, displayEmpty } = _a, props = __rest(_a, ["options", "children", "lastOptionRef", "placeholder", "renderValue", "value", "displayEmpty"]);
    const renderedOptions = (0, react_1.useMemo)(() => (options.map(({ label, value, disabled }, index) => (react_1.default.createElement(select_styles_1.StyledMenuItem, { key: value, value: value, disabled: disabled, ref: index === options.length - 1 && !!value ? lastOptionRef : undefined }, react_1.default.createElement(ui_components_1.Typography, { variant: "inherit", noWrap: true }, label))))), [options, lastOptionRef]);
    const resolvedRenderValue = (selected) => {
        const isEmptyValue = selected === '' || (Array.isArray(selected) && selected.length === 0);
        if (isEmptyValue && placeholder) {
            return react_1.default.createElement(ui_components_1.Typography, { variant: "inherit", color: "textSecondary", noWrap: true }, placeholder);
        }
        if (renderValue) {
            return renderValue(selected);
        }
        return Array.isArray(selected) ? selected.join(', ') : String(selected !== null && selected !== void 0 ? selected : '');
    };
    return (react_1.default.createElement(select_styles_1.StyledDropdown, Object.assign(Object.assign({}, props), { value: (value !== null && value !== void 0 ? value : ''), variant: "outlined", displayEmpty: displayEmpty !== null && displayEmpty !== void 0 ? displayEmpty : Boolean(placeholder), renderValue: resolvedRenderValue }), children, renderedOptions));
};
exports.Select = Select;
exports.default = exports.Select;
